import { type CollectionReference, asColRef } from '@principle-theorem/shared';
import {
  type IMigrationUploadSession,
  MigrationUploadSessionStatus,
} from '@principle-theorem/practice-migrations/interfaces';
import { RootCollection } from '@principle-theorem/principle-core/interfaces';

export class MigrationUploadSession {
  static col(): CollectionReference<IMigrationUploadSession> {
    return asColRef<IMigrationUploadSession>(
      RootCollection.MigrationUploadSessions
    );
  }

  static init(
    data: Omit<IMigrationUploadSession, 'status' | 'deleted'>
  ): IMigrationUploadSession {
    return {
      ...data,
      status: MigrationUploadSessionStatus.Pending,
      deleted: false,
    };
  }
}
